//containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '/containers-m/';

// context containers
import {
  Hero,
  BadgeRatings,
  TabsContent,
  PartnersIcons,
  VideoPlayer,
  ComparisonTable,
  Testimonials,
  SideCTA,
  SideFeatures,
  Form,
} from './containers/index';

//styles
import { PageWrapper } from './ShipperGuide.styles';

function ShipperGuide() {
  return (
    <PageWrapper>
      <Navigation theme="dark" />
      <>
        <Hero />
        <TabsContent />
        <Form />
        <PartnersIcons />
        <Testimonials />
        <BadgeRatings />
        <VideoPlayer />
        <ComparisonTable />
        <SideFeatures />
        <SideCTA />
      </>
      <Footer />
    </PageWrapper>
  );
}

export default ShipperGuide;
export { ShipperGuide };
